export default __webpack_public_path__ + "static/media/Female-5.d52b9fcb.svg";